import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ClientResponse } from 'types/ClientTypes';

import { ActivitiesProps, JobProps, TaggingListType } from '../../types/WorkLogTypes';

export interface WorkLogProps {
  clients: Array<ClientResponse>;
  jobs: Array<JobProps>;
  activities: Array<ActivitiesProps>;
  tagsList: Array<TaggingListType>;
  unreadNotificationCount: number;
  unsavedData: boolean;
  showSaveandExit: boolean;

  navigateURL: string | null;
}

const initialState: WorkLogProps = {
  jobs: [],
  clients: [],
  activities: [],
  tagsList: [],
  unreadNotificationCount: 0,
  unsavedData: false,
  showSaveandExit: false,
  navigateURL: null,
};

const worklogSlice = createSlice({
  name: 'worklog',
  initialState,
  reducers: {
    setClients: (state, action: PayloadAction<ClientResponse[]>) => {
      state.clients = action.payload;
    },
    setActivities: (state, action: PayloadAction<ActivitiesProps[]>) => {
      state.activities = action.payload;
    },
    setJobs: (state, action: PayloadAction<JobProps[]>) => {
      state.jobs = action.payload;
    },
    setTagList: (state, action: PayloadAction<TaggingListType[]>) => {
      state.tagsList = action.payload;
    },
    setNotifications: (state, action: PayloadAction<number>) => {
      state.unreadNotificationCount = action.payload;
    },
    setunsavedData: (
      state,
      action: PayloadAction<{ unsavedData?: boolean; showSaveandExit?: boolean; navigateURL?: string }>,
    ) => {
      const { unsavedData, showSaveandExit, navigateURL } = action.payload;
      if (unsavedData !== undefined) {
        state.unsavedData = unsavedData;
      }
      if (showSaveandExit !== undefined) {
        state.showSaveandExit = showSaveandExit;
      }
      if (navigateURL !== undefined) {
        state.navigateURL = navigateURL;
      }
    },

    resetunsavedData: (state) => {
      state.unsavedData = false;
      state.showSaveandExit = false;
      state.navigateURL = null;
    },
  },
});

export const { actions: worklogActions, reducer } = worklogSlice;

export default worklogSlice.reducer;
